import API from "../Utils/API";
export const getUserDeviceAction = (url) => (dispatch) => {
  dispatch({ type: "GET_USER_DEVICE_REQUEST" });
  API.get(url)
    .then((response) => {
      dispatch({ type: "GET_USER_DEVICE_SUCCESS", payload: response.data });
    })
    .catch((error) => {
      dispatch({
        type: "GET_USER_DEVICE_FAILURE",
        payload: error.response.data,
      });
    });
};
export const getUserDeviceById = (Id) => (dispatch) => {
  dispatch({ type: "GET_USER_DEVICE_BY_ID_REQUEST" });
  API.get(`api/devices/${Id}`)
    .then((response) => {
      dispatch({ type: "GET_USER_DEVICE_BY_ID_SUCCESS", payload: response.data });
    })
    .catch((error) => {
      dispatch({
        type: "GET_USER_DEVICE_BY_ID_FAILURE",
        payload: error.response.data,
      });
    });
};
export const createUserDeviceAction = (data, successCallback,failureCallback) => (dispatch) => {
  dispatch({ type: "CREATE_USER_DEVICE_REQUEST", payload: data });

  API.post("api/devices", data)
    .then((response) => {
      dispatch({ type: "CREATE_USER_DEVICE_SUCCESS", payload: response.data });
      successCallback && successCallback();
    })
    .catch((error) => {
      dispatch({
        type: "CREATE_USER_DEVICE_FAILURE",
        payload: error.response.data,
      });
      failureCallback && failureCallback(error.response.data);

    });
};

export const updateUserDeviceAction = (data, successCallback,failureCallback) => (dispatch) => {
  dispatch({ type: "UPDATE_USER_DEVICE_REQUEST" });
  API.put(`api/devices/${data.id}`, data)
    .then((response) => {
      dispatch({ type: "UPDATE_USER_DEVICE_SUCCESS", payload: response.data });
      successCallback();
    })
    .catch((error) => {
      dispatch({
        type: "UPDATE_USER_DEVICE_FAILURE",
        payload: error.response.data,
      });
      failureCallback && failureCallback(error.response.data);

    });
};


export const deleteUserUserDeviceAction =(Id, successCallback,failureCallback) => (dispatch) => {
    dispatch({ type: "DELETE_USER_DEVICE_REQUEST" });
    API.delete(`api/devices/${Id}`)
      .then((response) => {
        dispatch({
          type: "DELETE_USER_DEVICE_SUCCESS",
          payload: response.data,
        });
        successCallback();
      })
      .catch((error) => {
        dispatch({
          type: "DELETE_USER_DEVICE_FAILURE",
          payload: error.response.data,
        });
      failureCallback();
        
      });
  };
